export default "__VITE_PUBLIC_ASSET__f97a2cf4__"